import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Intro from "@/components/Intro";
import Services from "@/components/Services";
import WhyTillvia from "@/components/WhyTillvia";
import Process from "@/components/Process";
import Packages from "@/components/Packages";
import Subscriptions from "@/components/Subscriptions";
import PriceList from "@/components/PriceList";
import About from "@/components/About";
import CtaSection from "@/components/CtaSection";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import { scrollToId } from "@/lib/scroll";

export default function HomePage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash.slice(1)), 350);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [hash]);

  return (
    <div className="min-h-screen bg-navy">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Intro />
        <Services />
        <WhyTillvia />
        <Process />
        <Packages />
        <Subscriptions />
        <PriceList />
        <About />
        <CtaSection />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
